/** Base URL for ai-engine requests, passed into `@repo/agent-chat`'s query/mutation
 * definitions and this app's other direct ai-engine callers. */
export const AI_ENGINE_URL = import.meta.env.VITE_AI_ENGINE_URL || "http://localhost:8000";
